import React from 'react'

export default ({ className }) => (
  <svg
    fill="currentColor"
    className={className}
    width="92px"
    height="101px"
    viewBox="0 0 92 101"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <desc>Created with Sketch.</desc>
    <defs />
    <g
      id="Modal-+-Screen-grid"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd">
      <g
        id="Slide-Types-Grid"
        transform="translate(-2053.000000, -11314.000000)"
        fill="currentColor">
        <g id="Website" transform="translate(1763.000000, 11208.000000)">
          <path
            d="M350.585634,167.660934 C351.849434,170.636106 353.042563,173.454087 354.242717,176.269612 C357.264594,183.360821 360.292257,190.448755 363.311241,197.540373 C364.520488,200.380459 363.639383,202.505816 360.748101,203.730188 C357.334025,205.17602 353.917055,206.612437 350.497606,208.04517 C347.665423,209.232292 345.510187,208.377155 344.312098,205.571864 C340.42978,196.480969 336.557793,187.385981 332.679607,178.29304 C332.537027,177.958599 332.374609,177.632345 332.033656,176.898786 C331.680718,177.431353 331.504662,177.825969 331.217849,178.111287 C324.945966,184.343675 318.665404,190.567057 312.377404,196.783481 C310.476746,198.661998 308.372755,198.857259 306.479123,197.389322 C305.307484,196.481788 304.998353,195.250866 305.000007,193.854565 C305.010338,183.895435 305.004966,173.936304 305.004966,163.977173 C305.004966,142.149284 305.004139,120.320985 305.006206,98.492686 C305.006619,95.9420122 306.152634,94.5109168 308.527321,94.0712725 C309.891546,93.8191115 311.037562,94.2456565 312.002975,95.1986285 C314.22227,97.3894817 316.439498,99.582791 318.655072,101.777328 C338.328683,121.263314 357.999813,140.751755 377.680036,160.2316 C378.850434,161.390067 379.780306,162.600931 379.293053,164.372608 C378.673139,166.626092 377.334537,167.654384 374.943733,167.65725 C367.26547,167.666256 359.586794,167.660934 351.908119,167.660934 L350.585634,167.660934 Z"
            id="Fill-1"
            transform="translate(342.212716, 151.282495) rotate(-17.000000) translate(-342.212716, -151.282495) "
          />
        </g>
      </g>
    </g>
  </svg>
)
